<template>
  <div>
    <topbar
      :titulo="$t('PERFIS.PERFIS')"
      :subtitulo="$t('PERFIS.PERFIS_DESCRICAO')"
      :breadcrumbs="breadcrumbs"
    >
      <template #header v-if="podeCadastrar">
        <div class="d-flex justify-content-between ml-md-4">
          <div />
          <b-button @click="openModal('perfil')" variant="info" class="">
            {{ $t('PERFIS.CADASTRAR_PERFIL') }}
          </b-button>
        </div>
      </template>
    </topbar>

    <tabela-perfis :perfis="items" @irPara="irPara" @editar="openModal" @excluir="excluir"  @alterar-ordenacao="novaOrdenacao"/>

    <paginacao v-model="paginacao" :total="paginacao.total" @input="listar" />

    <modal-formulario-dados-perfil
      :exibir="modais.perfil"
      :item="modais.perfilDados"
      @atualizar="listar"
      @fechar="closeModal('perfil')"
    />
  </div>
</template>

<script>
// Utils & Aux:
import { START_LOADING, STOP_LOADING } from '@/store/Store';
import mensagem from '@/common/utils/mensagem';
import modais from '@/common/utils/modais';
import rotas from '@/common/utils/rotas';

// Services:
import PerfisService from '@/common/services/perfis/perfis.service';

// Components:
import ModalFormularioDadosPerfil from '@/views/acessos/perfis/components/ModalFormularioDadosPerfil';
import TabelaPerfis from './components/TabelaPerfis';
import Paginacao from '@/components/paginacao/Paginacao';
import Permisoes from '@/components/mixins/permissoes';
import Topbar from '@/layouts/full-layout/horizontal-sidebar/Topbar.vue';

export default {
  name: 'PerfisIndex',
  mixins: [Permisoes],
  components: {
    TabelaPerfis,
    Topbar,
    Paginacao,
    ModalFormularioDadosPerfil,
  },
  data() {
    return {
      items: [],
      table: {
        fields: [
          {
            key: 'nome',
            label: this.$t('PERFIS.NOME'),
            sortable: true,
          },
          {
            key: 'acoes',
            label: this.$t('GERAL.ACOES'),
          },
        ],
      },
      item: {},
      paginacao: {
        total: 0,
        numeroDaPagina: 1,
        tamanhoDaPagina: 10,
      },
      modais: {
        perfil: false,
        perfilDados: {},
      },
      campoOrdenado: null,
      ordem: false,
    };
  },
  computed: {
    breadcrumbs() {
      if (this.$route?.params?.linkRetornar === 'rh') {
        return [
          { titulo: this.$t('RH.RECURSOS_HUMANOS') },
          { titulo: this.$t('PERFIS.PERFIS') },
        ];
      } else {
        return [
          { titulo: this.$t('ADMIN.CONFIGURACOES') },
          { titulo: this.$t('ADMIN.PERFIS') },
        ];
      }
    },
    mostrarAcoes() {
      return this.podeEditar || this.podeExcluir;
    },
  },
  mounted() {
    this.listar();
  },
  methods: {
    listar() {
      this.$store.dispatch(START_LOADING);
      PerfisService.listar(this.paginacao, this.campoOrdenado, this.ordem)
        .then((result) => {
          let itens = result.data.itens;
          this.items = itens.reverse();
          this.paginacao.total = result.data.paginacao.totalDeElementos;
        })
        .catch((err) => {
          mensagem.erro(this.$t('GERAL.ERRO'), err.response.data.errors);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },
    excluir(item) {
      mensagem
        .confirmacao(
          null,
          this.$t('PERFIS.CONFIRMAR_EXCLUIR').formatUnicorn({
            nome: item.nome,
          })
        )
        .then(async (result) => {
          if (result.value) {
            this.$store.dispatch(START_LOADING);
            PerfisService.excluir(item.id)
              .then(() => {
                mensagem.sucesso(
                  this.$t('GERAL.SUCESSO'),
                  this.$t('PERFIS.PERFIL_EXCLUIDO_SUCESSO')
                );
                this.listar();
              })
              .catch((err) => {
                mensagem.showErrors(err);
              })
              .finally(() => {
                this.$store.dispatch(STOP_LOADING);
              });
          }
        });
    },
    openModal(key, item) {
      return modais.abrirModal(this, key, item);
    },
    closeModal(key) {
      return modais.fecharModal(this, key);
    },
    // FUNÇÕES AUXILIARES:
    irPara({ path, idPerfil }) {
      rotas.irPara(path, idPerfil);
    },
    abrirFormulario(id) {
      id
        ? this.$router.push({ name: 'editar-pessoa', params: { id } })
        : this.$router.push({ name: 'nova-pessoa' });
    },
    novaOrdenacao(campoOrdenado, ordem) {
      this.campoOrdenado = campoOrdenado;
      this.ordem = ordem;
      this.listar(); 
    },
  },
};
</script>
